import React from "react";
import styled from "styled-components";

import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import FileAttachmentItem from "./FileAttachmentItem";
import { findTranslatedTextForUser } from "../../Helpers/chatHelper/ChatHelper";

const ReplyMessageContainer = ({ message, handleClose, user }) => {

  return (
    <Container>

      <ContentWrapper>

        <MessageWrapper style={{ height: "100%" }}>
          <h1>{message.user.name}</h1>
          <MessageWrapper>
            <p>{findTranslatedTextForUser((message.message_translations), user).translation}</p>
          </MessageWrapper>
        </MessageWrapper>
        {message.document &&
          <FileAttachmentItem
            file={message.document}
          />
        }

        {message.video &&
          <img src={message.video.thumbnail.url} alt="reply_video" />
        }

        {message.image &&
          <img src={message.image.url} alt="reply_image" />
        }

      </ContentWrapper>
      <CloseBtn
  onMouseDown={(e) => e.preventDefault()}
  onClick={() => handleClose()}
>
  <CloseIcon />
</CloseBtn>



    </Container>
  );
};

export default ReplyMessageContainer;

const Container = styled.div`
display:flex;
align-items:center;
background:${({ theme }) => theme.chat.messageInputWrapperBackground};
border-top:1px solid ${({ theme }) => theme.sidebar.borderColor};
max-height:300px;
height:auto;
width:100%;
gap:20px;
padding:16px 20px;

@media(max-width:990px){
    max-height:100px;
}
`


const ContentWrapper = styled.div`
display:flex;
gap:20px;
border-left:4px solid ${({ theme }) => theme.primaryButton.color};
background:${({ theme }) => theme.chat.selectedBackground};
overflow:hidden;
padding:10px;
border-radius:4px;
gap:5px;
max-height:100px;
height:100%;
width: 100%;
position:relative;

img {
    max-width:400px;
    margin-left: auto;
    max-height: 80px;
  }

@media(max-width:990px){
    max-height:100px;
    img {
          max-height: 60px;
    }
}
`


const MessageWrapper = styled.div`
display:flex;
flex-direction:column;
overflow:hidden;
gap:5px;

max-height:100px;
height:100%;
width: 100%;
position:relative;
  h1 {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
  p {
    color:${({ theme }) => theme.menu.primaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  h2{
    opacity:0.8;
    color:${({ theme }) => theme.menu.selectedTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  h2{
    opacity:0.8;
    color:${({ theme }) => theme.menu.selectedTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
 img {
    max-width:400px;
    margin-left: auto;
    max-height: 80px;
  }

@media(max-width:990px){
    max-height:100px;
    img {
          max-height: 60px;
    }
}
`;
const CloseBtn = styled.button`
  margin-left: auto;
  border: none;
  background: none;
  cursor: pointer;
  svg{
height:28px;
width:28px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`;


const IconWrapper = styled.div`
display:flex;
margin-left:auto;
svg{
max-width:40px;
  max-height:40px;
}
`